import { Container } from 'pixi.js';
import { EASE, MainSignals, MoveCallData } from '../../settings/constants';
import { ResizeData } from '../../helpers/ResizeData';
import Scene0 from './scene/Scene0/Scene0';
import Scene1 from './scene/Scene1/Scene1';
import Scene2 from './scene/Scene2/Scene2';
import Scene3 from './scene/Scene3/Scene3';
import Scene4 from './scene/Scene4/Scene4';
import Scene5 from './scene/Scene5/Scene5';
import Scene6 from './scene/Scene6/Scene6';

const OFFSET_SCALE = 0.05;

export default class Scenes extends Container {
  center = {
    x: 0,
    y: 0,
  };
  offset = {
    x: 0,
    y: 0,
  };
  goal = {
    x: 0,
    y: 0,
  };

  constructor(signals: MainSignals) {
    super();

    // parts
    this.setScenes(signals);

    // listeners
    signals.resizeCall.add(this.resizeCall, this);
    signals.moveCall.add(this.moveCall, this);
    signals.tickCall.add(this.tickCall, this);
  }

  // --------------------------------------------------------------
  // Parts
  // --------------------------------------------------------------

  setScenes(signals: MainSignals): void {
    this.addChild(new Scene6(signals));
    this.addChild(new Scene5(signals));
    this.addChild(new Scene4(signals));
    this.addChild(new Scene3(signals));
    this.addChild(new Scene2(signals));
    this.addChild(new Scene1(signals));
    this.addChild(new Scene0(signals));
  }

  // --------------------------------------------------------------
  // Resize
  // --------------------------------------------------------------

  resizeCall(data: ResizeData): void {
    this.scale.set(data.stage.scale * (1 + OFFSET_SCALE));
    this.center.x = data.window.width * 0.5;
    this.center.y = data.window.height * 0.5;

    this.offset.x = data.window.width * OFFSET_SCALE;
    this.offset.y = data.window.height * OFFSET_SCALE;

    // reset position
    this.x = this.center.x;
    this.y = this.center.y;
    this.moveCall({ x: 0.5, y: 0.5 });
  }

  // --------------------------------------------------------------
  // Move
  // --------------------------------------------------------------

  moveCall(data: MoveCallData): void {
    this.goal.x = this.center.x - this.offset.x * (data.x - 0.5);
    this.goal.y = this.center.y - this.offset.y * (data.y - 0.5);
  }

  // --------------------------------------------------------------
  // Tick
  // --------------------------------------------------------------

  tickCall(): void {
    this.x += (this.goal.x - this.x) * EASE.SCENES;
    this.y += (this.goal.y - this.y) * EASE.SCENES;
  }
}
